import CaseDecisionParamMapper from "../../caseDecisions/service/CaseDecisionParamMapper";
import { ICourtCase } from "../model/CourtCase";

const CourtCaseParamMapper = (item: ICourtCase) => {
  return {
    ...item,
    decisions: item.decisions.map((item) => CaseDecisionParamMapper(item)),
    primaryDecisionId: item.primaryDecisionId
  };
};

export default CourtCaseParamMapper;
